import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CP_GO_URL_FAQ } from 'constants/go';
export var GoProductLinks = function GoProductLinks() {
  return React.createElement("li", null, React.createElement("a", {
    href: CP_GO_URL_FAQ,
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement(FormattedMessage, {
    id: "header.link.go.faq",
    defaultMessage: "FAQ"
  })));
};